import { TableView } from '@services/ui-services/models/table-view';

export const CUST_DETAIL_TAB: any[] = [
  {
    label: 'Activities',
    id: 'box-tab-pane',
    icon: 'subscription',
    active: true,
  },
  {
    label: 'Attributes',
    id: 'box2-tab-pane',
    icon: 'info',
    active: false,
  },
];
export const LOYALITY_SIDEBAR_TAB: any[] = [
  {
    label: 'Add points',
    id: 'addPoints',
    icon: 'info',
    active: true,
  },
  {
    label: 'Substract',
    id: 'substract',
    icon: 'balance',
    active: false,
  },
];

export const LOYALTY_TAB: any[] = [
  {
    label: 'Add points',
    id: 'addpoint-tab-pane',
    icon: 'info',
    active: true,
  },
  {
    label: 'Substract',
    id: 'substract-tab-pane',
    icon: 'truck',
    active: false,
  },
];

export const CAMPAIGN_TAB: any[] = [
  {
    label: 'Performance',
    id: 'performance-tab-pane',
    icon: 'performance.svg',
    active: true,
  },
  {
    label: 'History',
    id: 'history-tab-pane',
    icon: 'subscription',
    active: false,
  },
];

export const ORDER_TAB: any[] = [
  {
    label: 'Details',
    id: 'detail-tab-pane',
    icon: 'info',
    active: true,
  },
  {
    label: 'Tracking',
    id: 'track-tab-pane',
    icon: 'truck',
    active: false,
  },
  {
    label: 'Activity',
    id: 'activity-tab-pane',
    icon: 'subscription',
    active: false,
  },
];
export const LIBRARY_TABS: any[] = [
  {
    label: 'Available widgets',
    id: 'available-widgets',
    active: true,
    icon: '6',
  },
  { label: 'Already in use', id: 'already-widgets', active: false, icon: '3' },
];

export const DROPZONE: any[] = [
  {
    content: 'details',
    effectAllowed: 'move',
    disable: false,
    handle: false,
  },
  {
    content: 'segment',
    effectAllowed: 'move',
    disable: false,
    handle: false,
  },
  {
    content: 'address',
    effectAllowed: 'move',
    disable: false,
    handle: false,
  },
  {
    content: 'tags',
    effectAllowed: 'move',
    disable: false,
    handle: false,
  },
  {
    content: 'loyalty',
    effectAllowed: 'move',
    disable: false,
    handle: false,
  },
  {
    content: 'banking',
    effectAllowed: 'move',
    disable: false,
    handle: false,
  },
  {
    content: 'notifications',
    effectAllowed: 'move',
    disable: false,
    handle: false,
  },
];
export const DRAGZONE: any[] = [
  {
    content: 'details',
    effectAllowed: 'move',
    disable: false,
    handle: false,
  },
  {
    content: 'segment',
    effectAllowed: 'move',
    disable: false,
    handle: false,
  },
  {
    content: 'address',
    effectAllowed: 'move',
    disable: false,
    handle: false,
  },
  {
    content: 'tags',
    effectAllowed: 'move',
    disable: false,
    handle: false,
  },
  {
    content: 'loyalty',
    effectAllowed: 'move',
    disable: false,
    handle: false,
  },
  {
    content: 'banking',
    effectAllowed: 'move',
    disable: false,
    handle: false,
  },
  {
    content: 'notifications',
    effectAllowed: 'move',
    disable: false,
    handle: false,
  },
];

export const FOOTER_MENU: any[] = [
  {
    name: 'Avg',
    value: 'avg',
    icon: 'jam_hashtag',
    radio: false,
    showIcon: false,
    checkbox: false,
  },
  {
    name: 'Sum',
    value: 'sum',
    icon: 'balance',
    radio: false,
    showIcon: false,
    checkbox: false,
  },
  {
    name: 'Count',
    value: 'count',
    icon: 'list',
    radio: false,
    showIcon: false,
    checkbox: false,
  },
  {
    name: 'Max',
    value: 'max',
    icon: 'product',
    radio: false,
    showIcon: false,
    checkbox: false,
  },
];

export const CUSTOMER_TAB_ICONS: any = {
  overview: '📈',
  orders: '🛒',
  payments: '💳',
  subscriptions: '🔄',
  loyalty: '⭐️',
  kyc: '📑',
  campaigns: '🧩',
  conversations: '💬',
};

export const ATTRIBUTES = [
  // {
  //   property: 'full name',
  //   value: '',
  //   isDetail: false,
  //   isPin: true,
  //   isEditable: false,
  //   isRecentlyAdded: false,
  //   isTypeIcon: true,
  //   isSuccess: false,
  //   isActive: true,
  //   isPinAllowed: false,
  //   isLocked: false,
  //   isUpdate: true,
  //   isSave: false,
  // },
  // {
  //   property: 'phone',
  //   value: '',
  //   isDetail: false,
  //   isPin: false,
  //   isEditable: false,
  //   isRecentlyAdded: false,
  //   isTypeIcon: true,
  //   isSuccess: false,
  //   isActive: true,
  //   isPinAllowed: false,
  //   isLocked: false,
  //   isUpdate: true,
  //   isSave: false,
  // },
  // {
  //   property: 'email',
  //   value: '',
  //   isDetail: false,
  //   isPin: false,
  //   isEditable: false,
  //   isRecentlyAdded: false,
  //   isTypeIcon: true,
  //   isPinAllowed: false,
  //   isSuccess: false,
  //   isActive: true,
  //   isLocked: false,
  //   isUpdate: true,
  //   isSave: false,
  // },
  // {
  //   property: 'drug license number',
  //   value: '',
  //   isDetail: false,
  //   isPin: false,
  //   isEditable: false,
  //   isRecentlyAdded: false,
  //   isTypeIcon: true,
  //   isSuccess: false,
  //   isActive: true,
  //   isLocked: false,
  // },
  // {
  //   property: 'member since',
  //   value: '',
  //   isDetail: false,
  //   isPin: false,
  //   isEditable: false,
  //   isRecentlyAdded: false,
  //   isTypeIcon: true,
  //   isSuccess: false,
  //   isActive: true,
  //   isLocked: false,
  // },
  // {
  //   name: 'customer id',
  //   value: '',
  //   isDetail: false,
  //   isPin: false,
  //   isEditable: false,
  //   isRecentlyAdded: false,
  //   isTypeIcon: true,
  //   isSuccess: false,
  //   isActive: true,
  //   isLocked: false,
  // },
  // {
  //   name: 'Registration type',
  //   value: '',
  //   isDetail: false,
  //   isPin: false,
  //   isEditable: false,
  //   isRecentlyAdded: false,
  //   isTypeIcon: true,
  //   isSuccess: false,
  //   isActive: true,
  //   isLocked: false,
  // },
  // {
  //   name: 'pan number',
  //   value: '',
  //   isDetail: false,
  //   isPin: false,
  //   isEditable: false,
  //   isRecentlyAdded: false,
  //   isTypeIcon: true,
  //   isSuccess: false,
  //   isActive: true,
  //   isLocked: false,
  // },
  // {
  //   name: 'location',
  //   value: '',
  //   isDetail: false,
  //   isPin: false,
  //   isEditable: false,
  //   isRecentlyAdded: false,
  //   isTypeIcon: true,
  //   isSuccess: false,
  //   isActive: true,
  //   isLocked: false,
  // },
  // {
  //   name: 'lifetime tier points',
  //   value: '',
  //   isDetail: false,
  //   isPin: false,
  //   isEditable: false,
  //   isRecentlyAdded: false,
  //   isTypeIcon: true,
  //   isSuccess: false,
  //   isActive: true,
  //   isLocked: false,
  // },
  // {
  //   name: 'current tier points',
  //   value: '',
  //   isDetail: false,
  //   isPin: false,
  //   isEditable: false,
  //   isRecentlyAdded: false,
  //   isTypeIcon: true,
  //   isSuccess: false,
  //   isActive: true,
  //   isLocked: false,
  // },
  // {
  //   name: 'expired tier points',
  //   value: '',
  //   isDetail: false,
  //   isPin: false,
  //   isEditable: false,
  //   isRecentlyAdded: false,
  //   isTypeIcon: true,
  //   isSuccess: false,
  //   isActive: true,
  //   isLocked: false,
  // },
  // {
  //   name: 'club.ai points',
  //   value: '',
  //   isDetail: false,
  //   isPin: false,
  //   isEditable: false,
  //   isRecentlyAdded: false,
  //   isTypeIcon: true,
  //   isSuccess: false,
  //   isActive: true,
  //   isLocked: false,
  // },
  // {
  //   name: 'redemeed points',
  //   value: '',
  //   isDetail: false,
  //   isPin: false,
  //   isEditable: false,
  //   isRecentlyAdded: false,
  //   isTypeIcon: true,
  //   isSuccess: false,
  //   isActive: true,
  //   isLocked: false,
  // },
  // {
  //   name: 'next tier reset',
  //   value: '',
  //   isDetail: false,
  //   isPin: false,
  //   isEditable: false,
  //   isRecentlyAdded: false,
  //   isTypeIcon: true,
  //   isSuccess: false,
  //   isActive: true,
  //   isLocked: false,
  // },
  // {
  //   name: 'total savings',
  //   value: '',
  //   isDetail: false,
  //   isPin: false,
  //   isEditable: false,
  //   isRecentlyAdded: false,
  //   isTypeIcon: true,
  //   isSuccess: false,
  //   isActive: true,
  //   isLocked: false,
  // },
  // {
  //   name: 'total purchase',
  //   value: '',
  //   isDetail: false,
  //   isPin: false,
  //   isEditable: false,
  //   isRecentlyAdded: false,
  //   isTypeIcon: true,
  //   isSuccess: false,
  //   isActive: true,
  //   isLocked: false,
  // },
];

export const ADDRESSES: any = [
  {
    address: {
      title: 'Main office',
      type: 'default',
      address: {
        line1: 'Shop No.9, Ishwari Market, Kahu Kothi',
        city: 'KKanpur',
        state: 'Uttar Pradesh',
        pin: 'PIN- 208001',
        phone: '9260988261',
      },
    },
    state: 'active',
    type: 'address-piece',
  },
  {
    address: {
      title: 'Main office 1',
      type: 'none',
      address: {
        line1: 'Shop No.10, Ishwari Market, Kahu Kothi',
        city: 'KKanpur',
        state: 'Uttar Pradesh',
        pin: 'PIN- 208001',
        phone: '9260988261',
      },
    },
    state: 'default',
    type: 'address-piece',
  },
  {
    address: {
      title: 'Second hq',
      type: 'none',
      address: {
        line1: 'Shop No.11, Ishwari Market, Kahu Kothi',
        city: 'KKanpur',
        state: 'Uttar Pradesh',
        pin: 'PIN- 208001',
        phone: '9260988261',
      },
    },
    state: 'default',
    type: 'address-piece',
  },
];

export const CHANNEL = [
  { name: 'Amazon', icon: 'amazon', checkbox: false, showIcon: true },
  { name: 'Shopify', icon: 'amazon', checkbox: false, showIcon: true },
  { name: 'WooCommerce', icon: 'amazon', checkbox: false, showIcon: true },
  { name: 'Big Commerce', icon: 'amazon', checkbox: false, showIcon: true },
  { name: 'Wix', icon: 'amazon', checkbox: false, showIcon: true },
];

export const QUOTE_TYPE = [
  { name: 'Show all', icon: 'subscription', checkbox: true, showIcon: false },
  {
    name: 'Super saver price',
    icon: 'balance',
    checkbox: true,
    showIcon: false,
  },
  { name: 'Best Price', icon: 'list', checkbox: true, showIcon: false },
  {
    name: 'Saver Price',
    icon: 'jam_hashtag',
    checkbox: true,
    showIcon: false,
  },
  {
    name: 'Elite Qualifying Price',
    icon: 'product',
    checkbox: true,
    showIcon: false,
  },
];

export const TABLE_SCHEMA: TableView = {
  head: [
    {
      type: 'order',
      name: 'Orders',
      label: 'Orders',
      column: 'order_number',
      sortable: true,
      isShow: true,
      checkbox: true,
    },
    {
      type: 'string',
      name: 'Price',
      label: 'Price',
      column: 'grand_total',
      sortable: true,
      isShow: true,
      checkbox: true,
    },
    {
      type: 'string',
      name: 'Qty',
      label: 'Qty',
      column: 'items',
      sortable: true,
      isShow: true,
      checkbox: true,
    },
    {
      type: 'segment',
      name: 'Quote type',
      label: 'Quote type',
      column: 'reward_label',
      sortable: true,
      isShow: true,
      checkbox: true,
    },
    {
      type: 'string',
      name: 'Purchase date',
      label: 'Purchase date',
      column: 'order_date',
      sortable: true,
      isShow: true,
      checkbox: true,
    },
    {
      type: 'actions',
      label: '',
      sortable: false,
      isShow: true,
      checkbox: true,
      icon: '',
    },
  ],
  rows: [],
  data: [],
};

export const CAMPAIGN_TABLE: TableView = {
  head: [
    { type: 'checkbox', label: '', isShow: true },
    { type: 'string', label: 'Name', sortable: true, isShow: true },
    { type: 'badges', label: 'Status', sortable: true, isShow: true },
    { type: 'badges', label: 'Type', sortable: true, isShow: true },
    { type: 'string', label: 'Channel', sortable: true, isShow: true },
    { type: 'string', label: 'Start date', sortable: true, isShow: true },
  ],
  rows: [
    [
      { type: 'checkbox', label: '' },
      {
        type: 'campaign',
        campaign: {
          campaign_name: 'Rook',
          description: 'Help new customers understand the value they’ll receive from your product.',
        },
      },
      {
        type: 'status',
        status: {
          label: 'Active',
          Type: 'completed',
          IconType: 'no_icon',
        },
      },
      {
        type: 'status',
        status: {
          label: 'Event triggered',
          Type: 'tag',
          IconType: 'event',
        },
      },
      {
        type: 'channel',
        channel: [
          {
            icon: 'convert',
            channelName: 'Email',
            active: false,
          },
          {
            icon: 'convert',
            channelName: 'Mobile',
            active: false,
          },
          {
            icon: 'convert',
            channelName: 'Mobile',
            active: false,
          },
        ],
      },
      {
        type: 'text',
        text: {
          title: '31 Oct, 2022',
          cursor: '',
          color: '',
        },
      },
      {
        type: 'actions',
        label: '',
        actions: [
          {
            icon: 'chevron_right',
            text: '',
            active: false,
          },
        ],
      },
    ],
    [
      { type: 'checkbox', label: '' },
      {
        type: 'campaign',
        campaign: {
          campaign_name: 'Lopping',
          description: 'Help new customers understand the value they’ll receive from your product.',
        },
      },
      {
        type: 'status',
        status: {
          label: 'Active',
          Type: 'completed',
          IconType: 'no_icon',
        },
      },
      {
        type: 'status',
        status: {
          label: 'Segment triggered',
          Type: 'tag',
          IconType: 'event',
        },
      },
      {
        type: 'channel',
        channel: [
          {
            icon: 'convert',
            channelName: 'Email',
            active: false,
          },
          {
            icon: 'convert',
            channelName: 'Mobile',
            active: false,
          },
          {
            icon: 'convert',
            channelName: 'Mobile',
            active: false,
          },
        ],
      },
      {
        type: 'text',
        text: {
          title: '31 Oct, 2022',
          cursor: '',
          color: '',
        },
      },
      {
        type: 'actions',
        label: '',
        actions: [
          {
            icon: 'more',
            text: '',
            active: false,
          },
          {
            icon: 'chevron_right',
            text: '',
            active: false,
          },
        ],
      },
    ],
    [
      { type: 'checkbox', label: '' },
      {
        type: 'campaign',
        campaign: {
          campaign_name: 'Solo Mobile',
          description: 'Help new customers understand the value they’ll receive from your product.',
        },
      },
      {
        type: 'status',
        status: {
          label: 'Draft',
          Type: 'tag',
          IconType: 'no_icon',
        },
      },
      {
        type: 'status',
        status: {
          label: 'Date triggered',
          Type: 'tag',
          IconType: 'event',
        },
      },
      {
        type: 'channel',
        channel: [
          {
            icon: 'convert',
            channelName: 'Email',
            active: false,
          },
          {
            icon: 'convert',
            channelName: 'Mobile',
            active: false,
          },
          {
            icon: 'convert',
            channelName: 'Mobile',
            active: false,
          },
        ],
      },
      {
        type: 'text',
        text: {
          title: '31 Oct, 2022',
          cursor: '',
          color: '',
        },
      },
      {
        type: 'actions',
        label: '',
        actions: [
          {
            icon: 'more',
            text: '',
            active: false,
          },
          {
            icon: 'chevron_right',
            text: '',
            active: false,
          },
        ],
      },
    ],
    [
      { type: 'checkbox', label: '' },
      {
        type: 'campaign',
        campaign: {
          campaign_name: 'Enmeet',
          description: 'Help new customers understand the value they’ll receive from your product.',
        },
      },
      {
        type: 'status',
        status: {
          label: 'Stopped',
          Type: 'cancelled',
          IconType: 'no_icon',
        },
      },
      {
        type: 'status',
        status: {
          label: 'Event triggered',
          Type: 'tag',
          IconType: 'event',
        },
      },
      {
        type: 'channel',
        channel: [
          {
            icon: 'convert',
            channelName: 'Email',
            active: false,
          },
          {
            icon: 'convert',
            channelName: 'Mobile',
            active: false,
          },
          {
            icon: 'convert',
            channelName: 'Mobile',
            active: false,
          },
        ],
      },
      {
        type: 'text',
        text: {
          title: '31 Oct, 2022',
          cursor: '',
          color: '',
        },
      },
      {
        type: 'actions',
        label: '',
        actions: [
          {
            icon: 'more',
            text: '',
            active: false,
          },
          {
            icon: 'chevron_right',
            text: '',
            active: false,
          },
        ],
      },
    ],
  ],
  data: [],
};

export const FOOTER_LINKS = [
  {
    label: 'Start selected',
    active: false,
    IconType: 'coupon',
    disabled: false,
    alert: false,
  },
];
